import { useState } from 'react'
import { apiClient } from '../../api/client'
import { useAuthStore } from '../../stores/authStore'

export default function SettingsPage() {
  const { user } = useAuthStore()
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState<string | null>(null)

  const handleSave = async () => {
    setSaving(true)
    setMessage(null)
    try {
      await apiClient.post('/api/v1/settings/profile/', {})
      setMessage('Settings saved')
    } catch (e) {
      setMessage((e as Error).message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="max-w-2xl space-y-4">
      <h1 className="text-xl font-semibold text-gray-900">Settings</h1>
      <div className="rounded-lg border border-gray-200 bg-white p-4 space-y-3">
        <p className="text-sm text-gray-700">
          User: <span className="font-medium text-gray-900">{user?.full_name}</span>
        </p>
        <p className="text-sm text-gray-700">Tenant settings are centrally managed; limited personal settings exposed here.</p>
        <button
          onClick={handleSave}
          disabled={saving}
          className="rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 disabled:opacity-60"
        >
          {saving ? 'Saving…' : 'Save'}
        </button>
        {message && (
          <div className="text-sm text-gray-700" role="status">
            {message}
          </div>
        )}
      </div>
    </div>
  )
}
